import React from 'react';
import { useTranslation } from 'react-i18next';
import { GraphQLFormattedError } from 'graphql';
import { Values, FieldItem } from '@lib/interfaces/form';
import Form from '@lib/components/ReactHookForm/FormContainer';
import replaceNullsWithUndefined from '@lib/utils/replaceNullsWithUndefined';
import { getAreaFields } from 'routes/Sites/utils/getSiteFormFields';
import AreaEditFormActions from './AreaEditFormActions';

export interface FormProps {
  areaData?: Values;
  graphQLErrors?: readonly GraphQLFormattedError[];
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: Values) => void;
}

function AreaEditForm(props: FormProps) {
  const { areaData, graphQLErrors, loading, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const fields: FieldItem[] = getAreaFields({
    isEditForm: true,
    t,
  });

  return (
    <Form
      actionsComponent={AreaEditFormActions}
      actionsComponentProps={{ onCancel }}
      defaultValues={areaData ? replaceNullsWithUndefined(areaData) : {}}
      fields={fields}
      formId="area-edit"
      graphQLErrors={graphQLErrors}
      loading={loading}
      onSubmit={onSubmit}
    />
  );
}

export default AreaEditForm;
